import Combine from '../../components/Combine/Combine'
import ContactUs from './ContactUs'

const Contact = () => {
  return (
    <Combine>
      <ContactUs/>
    </Combine>
  )
}

export default Contact
